import React from 'react';
import Avatar from '../../common/Avatar';
import { useSelector } from 'react-redux';

function SideNav({ user, tabs, activeTab, onSelect }) {
    const userProfile = useSelector((state) => state.auth.user);

    const Icons = {
        personalInfo: 'user',
        work: 'portfolio',
        education: 'study',
        skills: 'cup',
        languages: 'global',
        references: 'users',
        certifications: 'ribbon'
    };

    return (
        <div className="cv-sidenav" style={{marginLeft: '1em'}}>
            <div className="cv-personal" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Avatar name={`${userProfile.profile.name} ${userProfile.profile.family_name}`} />
                <div>
                    <p style={{ margin: 0, fontWeight: 'bold', fontSize: '20px' }}>
                        {user.data.userGeneralInfo.firstName} {user.data.userGeneralInfo.lastName}
                    </p>
                    <p style={{ margin: 0, fontSize: '18px', color: '#666'}}>
                        {user.data.tenant.syncName}
                    </p>
                </div>
            </div>
            <ul>
                {tabs.map((tab) => (
                    <li
                        key={tab.id}
                        className={tab.id === activeTab ? 'active' : ''}
                        onClick={() => onSelect(tab.id)}
                        style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}
                    >
                        <div
                            className={`pe-7s-${Icons[tab.id]}`}
                            style={{
                                fontSize: '24px',
                                marginRight: '10px',
                            }}
                        ></div>
                        {tab.title}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default SideNav;
